/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIntersectionObserver } from '../../../hooks/useObserver';
import styles from '../../../../styles/blocks/employee/intersecting-video.module.scss';

const propTypes = {
    src: PropTypes.string,
    type: PropTypes.string,
    loop: PropTypes.bool,
    autoPlay: PropTypes.bool,
    muted: PropTypes.bool,
    preload: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    src: null,
    type: 'video/mp4',
    loop: true,
    autoPlay: true,
    muted: true,
    preload: 'metadata',
    className: null,
};

const IntersectingVideo = ({ src, type, loop, autoPlay, muted, preload, className, ...props }) => {
    const {
        ref,
        entry: { isIntersecting = true },
    } = useIntersectionObserver({ rootMargin: '0%' });

    useEffect(() => {
        if (ref.current !== null) {
            if (isIntersecting) {
                try {
                    ref.current.play().catch((e) => {
                        console.error('‼️', e);
                    });
                } catch (e) {
                    console.error('❗️', e);
                }
            } else if (!ref.current.paused) {
                ref.current.pause();
            }
        }
    }, [ref.current, isIntersecting]);

    return (
        <video
            className={classNames([styles.container, { [className]: className !== null }])}
            ref={ref}
            playsInline
            autoPlay={autoPlay}
            loop={loop}
            muted={muted}
            preload={preload}
            {...props}
        >
            <source type={type} src={src} />
        </video>
    );
};

IntersectingVideo.propTypes = propTypes;
IntersectingVideo.defaultProps = defaultProps;

export default IntersectingVideo;
